// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"c7894bd58dbf5a1d","6831":"a22d2042e5f042ce","8503":"88efec10d438aae5","9683":"6480014a003f55ba"}[chunkId] + ".js";
};